import { useAuthenticated } from "../../authn";
import { FeatureFlag, useFeatureFlagValue } from "../../feature-flags";

/**
 * Composite gate for eval golden steward UI.
 * Requires LaunchDarkly flag and AgenticProvisioner role (DEV bypasses role check).
 */
export function useEvalStewardEnabled() {
  const auth = useAuthenticated();
  const isFlagEnabled = useFeatureFlagValue(FeatureFlag.EnableEvalGoldenSteward);

  const isProvisioner =
    auth.state === "authenticated" &&
    (import.meta.env.DEV || auth.roles.includes("AgenticProvisioner"));

  return {
    isEvalStewardEnabled: isFlagEnabled && isProvisioner,
    isFlagEnabled,
    isProvisioner,
  };
}
